export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";